import ReactDOM from 'react-dom';
import React, { useRef, useLayoutEffect, useState, useImperativeHandle } from 'react';

import './index.less';

export default React.forwardRef(function SummaryDialog(props, ref) {
  const id = useRef('outerModal_' + Date.now());
  const { onShow = () => {}, onHide = () => {} } = props;
  const [show, setShow] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      show: () => {
        setShow(true);
        onShow();
      },
      hide: () => {
        setShow(false);
        onHide();
      },
    };
  });

  const elRef = useRef(document.querySelector('#' + id.current));

  if (!elRef.current) {
    elRef.current = document.createElement('div');
    elRef.current.id = id.current;
    document.body.appendChild(elRef.current);
  }

  useLayoutEffect(() => {
    return () => {
      elRef.current.parentNode.removeChild(elRef.current);
      elRef.current = null;
    };
  }, []);

  return ReactDOM.createPortal(
    <div onClick={(ev) => ref.current.hide()} className={'jd-dialog-mask ' + (show ? 'show' : '')}>
      <div onClick={(ev) => ev.stopPropagation()} className="jd-dialog-content">
        {props.children}
      </div>
    </div>,
    elRef.current
  );
});
